export default {
  // 通用
  'admin.fetchFailed': '数据获取失败，请稍后重试',
  'admin.operationFailed': '操作失败',
  'admin.pagination': '第 {start} - {end} 条，共 {total} 条',
  'admin.delete': '删除',
  'admin.cancel': '取消',
  'admin.update': '更新',
  'admin.create': '创建',
  'admin.close': '关闭',
  'admin.notLoggedIn': '未登录',

  // 用户管理列表
  'admin.user.title': '用户管理',
  'admin.user.colUsername': '用户名',
  'admin.user.colEmail': '邮箱',
  'admin.user.colRole': '角色',
  'admin.user.colStatus': '状态',
  'admin.user.colPermissionCount': '权限数量',
  'admin.user.colCreatedAt': '创建时间',
  'admin.user.colLastLogin': '最后登录',
  'admin.user.colActions': '操作',

  // 用户管理操作结果
  'admin.user.updateSuccess': '用户更新成功',
  'admin.user.updateFailed': '用户更新失败',
  'admin.user.createRequirePassword': '创建用户时必须填写密码',
  'admin.user.createSuccess': '用户创建成功',
  'admin.user.createFailed': '用户创建失败',
  'admin.user.deleteSuccess': '用户删除成功',
  'admin.user.deleteFailed': '用户删除失败',

  // 用户角色显示
  'admin.user.roleSuperAdmin': '超级管理员',
  'admin.user.roleAdmin': '管理员',
  'admin.user.roleOperator': '操作员',
  'admin.user.roleViewer': '只读用户',

  // 用户状态
  'admin.user.formStatusActive': '启用',
  'admin.user.formStatusInactive': '停用',
  'admin.user.formStatusSuspended': '已冻结',

  // 用户其他展示
  'admin.user.permissionsCount': '权限：{count} 项',
  'admin.user.neverLogin': '从未登录',
  'admin.user.tooltipEdit': '编辑用户',
  'admin.user.tooltipDelete': '删除用户',
  'admin.user.deleteConfirmTitle': '确认删除该用户？',
  'admin.user.deleteConfirmDesc': '删除后该用户将无法登录系统，此操作不可恢复。',
  'admin.user.newUser': '新建用户',
  'admin.user.editUser': '编辑用户',

  // 用户表单校验与标签
  'admin.user.formCheckInput': '请检查表单输入是否完整、格式是否正确',
  'admin.user.formUsername': '用户名',
  'admin.user.formUsernameRequired': '请输入用户名',
  'admin.user.formUsernameMin': '用户名至少 3 个字符',
  'admin.user.formUsernamePattern': '用户名只能包含字母、数字和下划线',
  'admin.user.formUsernamePlaceholder': '请输入用户名',

  'admin.user.formEmail': '邮箱',
  'admin.user.formEmailRequired': '请输入邮箱地址',
  'admin.user.formEmailInvalid': '邮箱格式不正确',
  'admin.user.formEmailPlaceholder': '请输入邮箱地址',

  'admin.user.formRole': '角色',
  'admin.user.formRoleRequired': '请选择角色',
  'admin.user.formRolePlaceholder': '请选择角色',

  'admin.user.formStatus': '状态',
  'admin.user.formStatusRequired': '请选择状态',
  'admin.user.formStatusPlaceholder': '请选择用户状态',

  'admin.user.formPassword': '密码',
  'admin.user.formPasswordRequired': '请输入密码',
  'admin.user.formPasswordMin': '密码至少 6 位字符',
  'admin.user.formPasswordPlaceholder': '请输入密码',
  'admin.user.formResetPassword': '重置密码',
  'admin.user.formResetPasswordHint': '留空则不修改密码；填写后将直接覆盖该用户登录密码',
  'admin.user.formResetPasswordPlaceholder': '输入新密码以重置',
  'admin.user.resetPasswordSuccess': '用户信息与密码已更新',

  // 角色管理 - 通用与结果
  'admin.role.title': '角色管理',
  'admin.role.newRole': '新建角色',
  'admin.role.editRole': '编辑角色',
  'admin.role.updateSuccess': '角色更新成功',
  'admin.role.updateFailed': '角色更新失败',
  'admin.role.createSuccess': '角色创建成功',
  'admin.role.createFailed': '角色创建失败',
  'admin.role.deleteSuccess': '角色删除成功',
  'admin.role.deleteFailed': '角色删除失败',

  // 角色等级展示
  'admin.role.levelHighest': '最高级',
  'admin.role.levelHigh': '高级',
  'admin.role.levelMedium': '中级',
  'admin.role.levelLow': '基础级',
  'admin.role.levelLabel': '等级 {level}',

  // 角色列表列头
  'admin.role.colName': '角色标识',
  'admin.role.colDescription': '角色描述',
  'admin.role.colLevel': '级别',
  'admin.role.colPermissionCount': '权限数量',
  'admin.role.colActions': '操作',

  // 角色列表操作提示
  'admin.role.tooltipView': '查看详情',
  'admin.role.tooltipEdit': '编辑角色',
  'admin.role.tooltipDelete': '删除角色',
  'admin.role.deleteConfirmTitle': '确认删除该角色？',
  'admin.role.deleteConfirmDesc': '删除后拥有此角色的用户将失去对应权限，请谨慎操作。',

  // 角色表单
  'admin.role.formName': '角色标识',
  'admin.role.formNameRequired': '请输入角色标识',
  'admin.role.formNameMin': '角色标识至少 2 个字符',
  'admin.role.formNamePattern': '角色标识只能包含字母、数字和下划线',
  'admin.role.formNamePlaceholder': '例如：operator，viewer',

  'admin.role.formDescription': '角色描述',
  'admin.role.formDescriptionRequired': '请输入角色描述',
  'admin.role.formDescriptionMax': '角色描述不能超过 200 个字符',
  'admin.role.formDescriptionPlaceholder': '请输入该角色的用途说明',

  'admin.role.formLevel': '角色等级',
  'admin.role.formLevelRequired': '请选择角色等级',
  'admin.role.formLevelExtra': '数值越小权限越高，超级管理员为最高等级',
  'admin.role.formLevelPlaceholder': '请选择角色等级',

  'admin.role.formPermissions': '权限列表',
  'admin.role.formPermissionsRequired': '请至少选择一个权限',
  'admin.role.formPermissionsExtra': '勾选该角色可以访问和执行的系统功能',

  // 角色权限穿梭框
  'admin.role.transferTitleLeft': '可用权限',
  'admin.role.transferTitleRight': '已选权限',
  'admin.role.transferItemUnit': '项',
  'admin.role.transferItemsUnit': '项',
  'admin.role.transferSearchPlaceholder': '搜索权限',
  'admin.role.transferNotFound': '未找到匹配的权限',

  // 角色详情
  'admin.role.detailTitle': '角色详情 - {name}',
  'admin.role.descName': '角色标识',
  'admin.role.descLevel': '角色等级',
  'admin.role.descDescription': '角色描述',
  'admin.role.descPermissionCount': '权限数量',
  'admin.role.permissionDetails': '权限明细',

  // 权限管理 - 分类名称
  'admin.permission.categoryDashboard': '仪表板',
  'admin.permission.categoryProduct': '产品管理',
  'admin.permission.categoryOrder': '订单管理',
  'admin.permission.categoryDear': 'DEAR 数据',
  'admin.permission.categoryLog': '日志管理',
  'admin.permission.categorySystem': '系统管理',

  // 权限管理 - 通用与结果
  'admin.permission.title': '权限管理',
  'admin.permission.overview': '权限概览',
  'admin.permission.newPermission': '新建权限',
  'admin.permission.editPermission': '编辑权限',
  'admin.permission.createSuccess': '权限创建成功',
  'admin.permission.createFailed': '权限创建失败',
  'admin.permission.updateSuccess': '权限更新成功',
  'admin.permission.updateFailed': '权限更新失败',
  'admin.permission.deleteSuccess': '权限删除成功',
  'admin.permission.deleteFailed': '权限删除失败',

  // 权限管理 - 列表列头
  'admin.permission.colName': '权限名称',
  'admin.permission.colId': '权限 ID',
  'admin.permission.colCategory': '分类',
  'admin.permission.colResource': '资源',
  'admin.permission.colActions': '操作',
  'admin.permission.colDescription': '描述',

  // 权限管理 - 操作提示
  'admin.permission.tooltipView': '查看详情',
  'admin.permission.tooltipEdit': '编辑权限',
  'admin.permission.tooltipDelete': '删除权限',
  'admin.permission.deleteConfirmTitle': '确认删除该权限？',
  'admin.permission.deleteConfirmDesc': '删除后将解除所有角色对此权限的绑定，此操作不可恢复。',

  // 权限管理 - 表单
  'admin.permission.formName': '权限名称',
  'admin.permission.formNameRequired': '请输入权限名称',
  'admin.permission.formNameMin': '权限名称至少 2 个字符',
  'admin.permission.formNamePlaceholder': '例如：查看产品列表',

  'admin.permission.formDescription': '权限描述',
  'admin.permission.formDescriptionRequired': '请输入权限描述',
  'admin.permission.formDescriptionMax': '权限描述不能超过 200 个字符',
  'admin.permission.formDescriptionPlaceholder': '请输入该权限的用途说明',

  'admin.permission.formCategory': '分类',
  'admin.permission.formCategoryRequired': '请选择分类',
  'admin.permission.formCategoryPlaceholder': '请选择权限所属分类',

  'admin.permission.formResource': '资源',
  'admin.permission.formResourceRequired': '请输入资源',
  'admin.permission.formResourcePlaceholder': '例如：product, order',

  'admin.permission.formAction': '操作',
  'admin.permission.formActionRequired': '请输入操作',
  'admin.permission.formActionPlaceholder': '例如：read, write, delete',

  // 权限管理 - 详情
  'admin.permission.detailTitle': '权限详情 - {name}',
  'admin.permission.descId': '权限 ID',
  'admin.permission.descName': '权限名称',
  'admin.permission.descCategory': '分类',
  'admin.permission.descResource': '资源',
  'admin.permission.descAction': '操作',
  'admin.permission.descDescription': '描述',

  // 系统设置页
  'admin.settings.fetchFailed': '获取系统设置失败，请稍后重试',
  'admin.settings.saveSuccess': '设置保存成功',
  'admin.settings.saveFailed': '设置保存失败',
  'admin.settings.inputNumber': '请输入合法的数字',
  'admin.settings.extraComma': '多个值请使用英文逗号分隔',
  'admin.settings.placeholderComma': '例如：value1,value2,value3',
  'admin.settings.extraJson': '请输入合法的 JSON 格式配置',
  'admin.settings.placeholderJson': '例如：{"key":"value"}',
  'admin.settings.loading': '正在加载系统设置...',
  'admin.settings.alertTitle': '系统配置说明',
  'admin.settings.alertDesc': '在这里可以查看和调整系统的关键配置，修改前请确认含义。',
  'admin.settings.configCount': '共 {count} 项配置',
  'admin.settings.view': '查看',
  'admin.settings.edit': '编辑',
  'admin.settings.moreConfig': '还有 {count} 项配置',
  'admin.settings.modalTitle': '{section} 配置详情',
  'admin.settings.modalConfigItem': '{section} 配置项',
  'admin.settings.modalConfigCount': '共 {count} 项配置',
  'admin.settings.saveConfig': '保存配置',
};
